import assert from "assert"
import { GLTF } from "three/examples/jsm/Addons.js"
import * as THREE from "three/webgpu"
import { FolderApi } from "tweakpane"

import Puddle from "./Puddle"

type RoofProps = {
  resources: {
    [key: string]: GLTF
  }
  scene: THREE.Scene
  debugFolder?: FolderApi
  camera: THREE.PerspectiveCamera
}

export default class Roof {
  scene: THREE.Scene
  debugFolder?: FolderApi
  camera: THREE.PerspectiveCamera

  model!: THREE.Object3D
  material!: THREE.MeshStandardNodeMaterial
  puddle!: Puddle

  buildingsMaterials: THREE.MeshPhysicalMaterial[] = []

  constructor({ resources, scene, camera, debugFolder }: RoofProps) {
    const model = resources.blender.scene?.getObjectByName("Roof")
    assert(model, "Roof model not found")

    this.model = model

    this.scene = scene
    this.camera = camera
    this.debugFolder = debugFolder

    this.scene.add(model)
  }
}
